import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import {
  AuthService,
  EventApplicationService,
  EventService,
} from "../../../../services";
import { BusinessProfileModel } from "../../../../components/Model/businessProfileModel";
import { CaterApplicationFormModel } from "../../../../components/Model/CaterApplicationFormModel";
import { getBusinessProfileById } from "../../../../services/BusinessProfileService";
import { getStateList } from "../../../../services/StateService";
import { getCountryList } from "../../../../services/CountryService";
import { TraderUnitService } from "../../../../services";
import TimePicker from "../../../../components/Common/Timepicker";
import {
  formatDateENGB,
  handleConsoleError,
} from "../../../../utils/common-methods";
import { globalConstant } from "../../../../constants/globalConstant";
import { toast } from "react-toastify";
const CaterBusinessDetails = () => {
  const loginUser = AuthService.getLoginUser();
  const { eventId, unitId } = useParams();
  const [businessData, setBusinessData] = useState(BusinessProfileModel);
  const [caterApplicationFormData, setCaterApplicationData] = useState(
    CaterApplicationFormModel
  );
  //const [isProfileAvailable, setIsProfileAvailable] = useState(true);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [stateList, setStateList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [expectedArrivalTime, setExpectedArrivalTime] = useState("");
  //.toISOString().split("T")[0]
  // const today = new Date();
  // const tomorrow = new Date(today.setHours(0, 0, 0, 0));
  // tomorrow.setDate(tomorrow.getDate() + 1);

  const [maxDate, setMaxDate] = useState(
    new Date(Date.now() + 86400000).toISOString().split("T")[0]
  );
  const minDate = new Date(Date.now() + 86400000).toISOString().split("T")[0];

  const {
    register,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const setSelectedCountry = (value) => {
    if (value) {
      setSelectedCountryId(value);
    } else {
      setSelectedCountryId("");
      setSelectedStateId("");
    }
  };
  const setSelectedState = (value) => {
    if (value) {
      setSelectedStateId(value);
    } else {
      setSelectedStateId("");
    }
  };

  const filteredStates = stateList.filter(
    (state) => state.countryId === selectedCountryId
  );

  const getCaterFormDetails = async () => {
    try {
      const selectedTraderUnit = TraderUnitService.getSelectedTraderUnit();
      setCaterInitialValue();
      const userId = loginUser?.id;
      const res = await EventApplicationService.getCaterApplicationByUnitTraderId(
        unitId,
        userId,
        selectedTraderUnit?.id
      );
      if (res?.isSuccess) {
        const caterApplicationFormMappedData = {
          ...caterApplicationFormData,
          ...res?.data,
        };
        caterApplicationFormMappedData.expectedArrivalTimeStr =
          caterApplicationFormMappedData.expectedArrivalTimeStr ??
          caterApplicationFormMappedData.expectedArrivalTime;

        caterApplicationFormMappedData.unitId = unitId;

        setValue("caterApplicationFormData", caterApplicationFormMappedData);
        setExpectedArrivalTime(
          caterApplicationFormMappedData?.expectedArrivalTimeStr
        );
      } else {
        setCaterInitialValue();
        setValue("caterApplicationFormData", caterApplicationFormData);
      }
    } catch (error) {
       handleConsoleError(error);
     // toast.error(error?.message|| message);
      setValue("caterApplicationFormData", caterApplicationFormData);
    }
  };

  const setCaterInitialValue = () => {
    caterApplicationFormData.eventId = eventId; //"C11D7DA2-DCC8-4970-B4FF-08DD298A1773";
    caterApplicationFormData.traderId = loginUser?.id;
    // caterApplicationFormData.eventApplicationId = appId;
    setCaterApplicationData(caterApplicationFormData);
  };

  const getBusinessProfile = async () => {
    try {
      const userId = loginUser?.id;
      const business = await getBusinessProfileById(userId);
      const stateList = await getStateList();
      const countryList = await getCountryList();
      var event = await EventService.getEventById(eventId);
      if (event?.data?.endDate) {
        const parsedDate = new Date(event.data.endDate);
        if (!isNaN(parsedDate)) {
          const day = String(parsedDate.getDate()).padStart(2, "0"); // Ensure two digits
          const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Ensure two digits
          const year = parsedDate.getFullYear();

          const correctedDate = `${year}-${month}-${day}`; // Correct ISO format
          setMaxDate(correctedDate);
        }
      } else {
        const parsedDate = new Date(Date.now() + 15 * 86400000);
        const day = String(parsedDate.getDate()).padStart(2, "0"); // Ensure two digits
        const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Ensure two digits
        const year = parsedDate.getFullYear();

        const correctedDate = `${year}-${month}-${day}`; // Correct ISO format
        setMaxDate(correctedDate);
      }
      if (business?.isSuccess) {
        business.data.video = "";
        const businessMappedData = {
          ...businessData,
          ...business?.data,
        };
        setValue("businessData", businessMappedData);
        setBusinessData(businessMappedData);

        setStateList(stateList.data || []);
        setCountryList(countryList.data || []);
        if (business?.data?.countryId) {
          setSelectedCountryId(business?.data?.countryId);
          setBusinessData((prev) => ({
            ...prev,
            country: countryList.data.find(
              (country) => country.id === business.data.countryId
            ),
          }));
        }
        if (business.data.stateId) {
          setSelectedStateId(business.data.stateId);
          setBusinessData((prev) => ({
            ...prev,
            state: stateList.data.find(
              (state) => state.id === business.data.stateId
            ),
          }));
        }
      } else {
      }
    } catch (error) {

     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const handleTimeChange = (value) => {
    setExpectedArrivalTime(value);
    let data = getValues("caterApplicationFormData");
    if (data) {
      data.expectedArrivalTimeStr = value;

      setValue("caterApplicationFormData.expectedArrivalTimeStr", value, {
        shouldValidate: true,
      });
    }
    if (!value) {
      setError("expectedArrivalTime", {
        message: "Expected arrival Time is required",
      });
    } else {
      clearErrors("expectedArrivalTime");
    }
  };

  useEffect(() => {
    getBusinessProfile();
    getCaterFormDetails();
  }, []);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Company Name <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your trading name"
              maxLength={100}
              type="text"
              {...register("businessData.businessName", {
                required: "Trading Name is required",
              })}
              defaultValue={businessData?.businessName}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.businessName && (
            <span className="text-danger">
              {errors.businessData?.businessName?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Contact Name <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your contact legal name"
              maxLength={100}
              type="text"
              {...register("businessData.contactlegalname", {
                required: "Contact Legal Name is required",
              })}
              defaultValue={businessData?.contactlegalname}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.contactlegalname && (
            <span className="text-danger">
              {errors.businessData?.contactlegalname?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            State <span className="text-danger">*</span>
            <Form.Control
              as="select"
              {...register("businessData.countryId", {
                required: "State is required",
              })}
              value={selectedCountryId}
              onChange={(e) => {
                setSelectedCountry(e.target.value);
              }}
            >
              <option value="">Select State</option>
              {countryList.map((country) => (
                <option key={country?.id} value={country?.id}>
                  {country?.countryName}
                </option>
              ))}
            </Form.Control>
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.countryId && (
            <span className="text-danger">
              {errors.businessData?.countryId?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Country <span className="text-danger">*</span>
            <Form.Control
              as="select"
              {...register("businessData.stateId", {
                required: "Country is required",
              })}
              value={selectedStateId}
              onChange={(e) => {
                setSelectedStateId(e.target.value);
                setSelectedState(e.target.value);
              }}
            >
              <option value="">Select Country</option>
              {filteredStates.map((state) => (
                <option key={state?.id} value={state?.id}>
                  {state?.stateName}
                </option>
              ))}
            </Form.Control>
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.stateId && (
            <span className="text-danger">
              {errors.businessData?.stateId?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Address <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your address"
              maxLength={200}
              type="text"
              {...register("businessData.address", {
                required: "Address is required",
              })}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.address && (
            <span className="text-danger">
              {errors.businessData?.address?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Town/City <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your city"
              maxLength={75}
              type="text"
              {...register("businessData.city", {
                required: "Town/City is required",
              })}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.city && (
            <span className="text-danger">
              {errors.businessData?.city?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Post Code <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your post code"
              maxLength={15}
              type="text"
              {...register("businessData.zipCode", {
                required: "Post Code is required",
                pattern: {
                  value: /^[A-Za-z0-9\s-]{3,10}$/,
                  message: "Invalid Postal Code",
                },
              })}
              defaultValue={businessData?.zipCode}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.zipCode && (
            <span className="text-danger">
              {errors.businessData?.zipCode?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Email Address <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your email address"
              maxLength={100}
              type="text"
              {...register("businessData.email", {
                required: "Email address is required",
                pattern: {
                  value: globalConstant.emailRegex,
                  message: "Invalid Email",
                },
              })}
              defaultValue={businessData?.email}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.email && (
            <span className="text-danger">
              {errors.businessData?.email?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Phone/Mobile Number <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your number"
              maxLength={15}
              type="text"
              {...register(
                "businessData.phone",
                {
                  required: "Phone number is required",
                },
                {
                  pattern: {
                    value: /^[0-9]\d{8,14}$/,
                    message: "Invalid phone number",
                  },
                }
              )}
              defaultValue={businessData?.phone}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.phone && (
            <span className="text-danger">
              {errors.businessData?.phone?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Business Registration Number <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your registration number"
              maxLength={8}
              type="text"
              {...register(
                "businessData.businessRegistrationNumber",
                {
                  required: "Registration number is required",
                },
                {
                  pattern: {
                    value: /^[a-zA-Z0-9]{8}$/,
                    message:
                      "The registration number must be  alphanumeric and be 8 digits long",
                  },
                }
              )}
              defaultValue={businessData?.businessRegistrationNumber}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.businessRegistrationNumber && (
            <span className="text-danger">
              {errors.businessData?.businessRegistrationNumber?.message}
            </span>
          )}

          <Form.Control
            type="hidden"
            {...register("caterApplicationFormData.id")}
            defaultValue={caterApplicationFormData?.id}
          />
          <Form.Control
            type="hidden"
            {...register("caterApplicationFormData.eventId")}
            defaultValue={caterApplicationFormData?.eventId}
          />
          <Form.Control
            type="hidden"
            {...register("caterApplicationFormData.traderId")}
            defaultValue={caterApplicationFormData?.traderId}
          />
          <Form.Control
            type="hidden"
            {...register("caterApplicationFormData.initialPaymentPer")}
            defaultValue={caterApplicationFormData?.initialPaymentPer}
          />

          <Form.Control
            type="hidden"
            {...register("caterApplicationFormData.eventApplicationId")}
            defaultValue={caterApplicationFormData?.eventApplicationId}
          />
          <Form.Control
            type="hidden"
            {...register("caterApplicationFormData.traderUnitId")}
            defaultValue={caterApplicationFormData?.traderUnitId}
          />

          {/* <Form.Control
            type="hidden"
            {...register("caterApplicationFormData.expectedArrivalTime")}
            defaultValue={caterApplicationFormData.expectedArrivalTime}
          /> */}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            On Site Contact Person <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter the contact person's name"
              maxLength={100}
              type="text"
              {...register("caterApplicationFormData.onSiteContact", {
                required: "On Site Contact Person is required",
                pattern: {
                  value: /^[a-zA-Z\s]+$/,
                  message: "Only letters and spaces are allowed",
                },
              })}
              defaultValue={caterApplicationFormData?.onSiteContact}
            />
            <span className="focus-border"></span>
          </div>
          {errors.caterApplicationFormData?.onSiteContact && (
            <span className="text-danger">
              {errors.caterApplicationFormData?.onSiteContact?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            On Site Tel <span className="text-danger">*</span>
            <Form.Control
              className="effect-4"
              placeholder="Enter your on site tel"
              maxLength={100}
              type="text"
              {...register("caterApplicationFormData.onSiteTel", {
                required: "On Site Tel is required",
              })}
              defaultValue={caterApplicationFormData?.onSiteTel}
            />
            <span className="focus-border"></span>
          </div>
          {errors.caterApplicationFormData?.onSiteTel && (
            <span className="text-danger">
              {errors.caterApplicationFormData?.onSiteTel?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            Expected Arrival Date <span className="text-danger">* </span>
            <Form.Control
              type="date"
              min={minDate || undefined}
              max={maxDate || undefined}
              {...register("caterApplicationFormData.expectedArrivalDate", {
                required: "Expected arrival date is required",
                min: {
                  value: minDate,
                  message: `Expected arrival date must be after ${formatDateENGB(
                    minDate || undefined
                  )}`,
                },
                max: {
                  value: maxDate,
                  message: `Expected arrival date must be before ${formatDateENGB(
                    maxDate || undefined
                  )}`,
                },
              })}
              placeholder="dd-mm-yyyy" // Placeholder in the desired format
            />
            <span className="focus-border"></span>
          </div>
          {errors?.caterApplicationFormData?.expectedArrivalDate && (
            <span className="text-danger">
              {errors?.caterApplicationFormData?.expectedArrivalDate?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            {/* <h3>
              Expected Arrival Time <span className="text-danger">*</span>
            </h3> */}
            <TimePicker
              label="Expected Arrival Time"
              value={expectedArrivalTime}
              onChange={(value) => handleTimeChange(value)}
              // error={
              //   errors.caterApplicationFormData?.expectedArrivalTimeStr?.message
              // }
            />
            {errors.expectedArrivalTime && (
              <span className="text-danger">
                {errors.expectedArrivalTime?.message}
              </span>
            )}
            {/* <Form.Control
          className="effect-4"
          placeholder="Enter your expected arrival time"
          maxLength={100}
          type="text"
          {...register("caterApplicationFormData.expectedArrivalTime", {
            required: "Expected arrival time is required",
          })}
          defaultValue={caterApplicationFormData.expectedArrivalTime}
        /> */}
            <span className="focus-border"></span>
          </div>
          {/* {errors.caterApplicationFormData?.expectedArrivalTimeStr && (
            <span className="text-danger">
              {errors.caterApplicationFormData?.expectedArrivalTimeStr.message}
            </span>
          )} */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CaterBusinessDetails;
